/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import ModalContainer from "@react/react-spectrum/ModalContainer";
import DialogContainer from "./DialogContainer";

export default class Dialog {
  constructor() {
    this.init();
  }

  init() {
    this._currDialog = null;
    this._currDialogKey = 0;
  }

  reset() {
    this.hide();
    this.init();
  }

  setIntl(intl) {
    this.intl = intl;
  }
  // dialogStyle here is style of react-spectrum dialog component specifically top here, for styling of inner content use props
  show(DialogType, props, dialogStyle) {
    let isDialogShowSuccessful = false;
    if (!this._currDialog) {
      if (DialogType) {
        this._currDialogKey = ModalContainer.show(
          <DialogContainer
            DialogComponent={DialogType}
            dialogStyle={dialogStyle}
            {...props}
            intl={this.intl}
            ref={dialog => {
              this._currDialog = dialog;
            }}
          />
        );
        isDialogShowSuccessful = true;
      } else {
        throw new Error("Unknown Dialog Type");
      }
    }
    return isDialogShowSuccessful;
  }

  hide() {
    let isDialogHideSuccessful = false;
    if (this._currDialog && this._currDialogKey) {
      ModalContainer.hide(this._currDialogKey);
      this._currDialog = null;
      this._currDialogKey = 0;
      isDialogHideSuccessful = true;
    }
    return isDialogHideSuccessful;
  }

  setDialogHasError(value) {
    if (this._currDialog) {
      this._currDialog.setDialogHasError(value);
    }
  }
}
